export default "/_next/static/media/Onboarding_2-473x1024.282221d3a6593a13a5dc463b3e740a56.png";